"use strict";
/**
 * Created by rouven on 23.02.17.
 */
exports.__esModule = true;
var Columns = function (props) {
    if (props === void 0) { props = undefined; }
    return null;
};
exports["default"] = Columns;
